import React from "react";
import ReactApexChart from "react-apexcharts";

const Chart = () => {
	const series = [
		{
			name: "candle",
			data: [
				{
					x: "Jan 01",
					y: [6629.81, 6650.5, 6623.04, 6633.33],
				},
				{
					x: "Jan 02",
					y: [6632.01, 6643.59, 6620, 6630.11],
				},
				{
					x: "Jan 03",
					y: [6630.71, 6648.95, 6623.34, 6635.65],
				},
				{
					x: "Jan 04",
					y: [6635.65, 6651, 6629.67, 6638.24],
				},
				{
					x: "Jan 05",
					y: [6638.24, 6640, 6620, 6624.47],
				},
				{
					x: "Jan 06",
					y: [6624.53, 6636.03, 6621.68, 6624.31],
				},
				{
					x: "Jan 07",
					y: [6624.61, 6632.2, 6617, 6626.02],
				},
				{
					x: "Jan 08",
					y: [6627, 6627.62, 6584.22, 6603.02],
				},
				{
					x: "Jan 09",
					y: [6605, 6608.03, 6598.95, 6604.01],
				},
				{
					x: "Jan 10",
					y: [6604.5, 6614.4, 6602.26, 6608.02],
				},
				{
					x: "Jan 11",
					y: [6608.02, 6610.68, 6601.99, 6608.91],
				},
				{
					x: "Jan 12",
					y: [6608.91, 6618.99, 6608.01, 6612],
				},
				{
					x: "Jan 13",
					y: [6612, 6615.13, 6605.09, 6612],
				},
				{
					x: "Jan 14",
					y: [6612, 6624.12, 6608.43, 6622.95],
				},
				{
					x: "Jan 15",
					y: [6623.91, 6623.91, 6615, 6615.67],
				},
				{
					x: "Jan 16",
					y: [6618.69, 6618.74, 6610, 6610.4],
				},
				// {
				// 	x: "Jan 17",
				// 	y: [6611, 6622.78, 6610.4, 6614.9],
				// },
				// {
				// 	x: "Jan 18",
				// 	y: [6614.9, 6626.2, 6613.33, 6623.45],
				// },
				// {
				// 	x: "Jan 19",
				// 	y: [6623.48, 6627, 6618.38, 6620.35],
				// },
				// {
				// 	x: "Jan 20",
				// 	y: [6619.43, 6620.35, 6610.05, 6615.53],
				// },
				// {
				// 	x: "Jan 21",
				// 	y: [6615.53, 6617.93, 6610, 6615.19],
				// },
				// {
				// 	x: "Jan 22",
				// 	y: [6615.19, 6621.6, 6608.2, 6620],
				// },
				// {
				// 	x: "Jan 23",
				// 	y: [6619.54, 6625.17, 6614.15, 6620],
				// },
				// {
				// 	x: "Jan 24",
				// 	y: [6620.33, 6634.15, 6617.24, 6624.61],
				// },
				// {
				// 	x: "Jan 25",
				// 	y: [6625.95, 6626, 6611.66, 6617.58],
				// },
				// {
				// 	x: "Jan 26",
				// 	y: [6619, 6625.97, 6595.27, 6598.86],
				// },
				// {
				// 	x: "Jan 27",
				// 	y: [6598.86, 6598.88, 6570, 6587.16],
				// },
				// {
				// 	x: "Jan 28",
				// 	y: [6588.86, 6600, 6580, 6593.4],
				// },
				// {
				// 	x: "Jan 29",
				// 	y: [6593.99, 6598.89, 6585, 6587.81],
				// },
				// {
				// 	x: "Jan 30",
				// 	y: [6587.81, 6592.73, 6567.14, 6578],
				// },
				// {
				// 	x: "Jan 31",
				// 	y: [6578.35, 6581.72, 6567.39, 6579],
				// },
				// {
				// 	x: "Feb 01",
				// 	y: [6579.38, 6580.92, 6566.77, 6575.96],
				// },
				// {
				// 	x: "Feb 02",
				// 	y: [6575.96, 6589, 6571.77, 6588.92],
				// },
				// {
				// 	x: "Feb 03",
				// 	y: [6588.92, 6594, 6577.55, 6589.22],
				// },
				// {
				// 	x: "Feb 04",
				// 	y: [6589.3, 6598.89, 6589.1, 6596.08],
				// },
				// {
				// 	x: "Feb 05",
				// 	y: [6597.5, 6600, 6588.39, 6596.25],
				// },
				// {
				// 	x: "Feb 06",
				// 	y: [6598.03, 6600, 6588.73, 6595.97],
				// },
				// {
				// 	x: "Feb 07",
				// 	y: [6595.97, 6602.01, 6588.17, 6602],
				// },
			],
		},
	];
	const options = {
		chart: {
			height: 350,
			toolbar: {
				show: false,
			},
		},
		colors: ["#CC68CE", "#95EB95", "#3ec9d6"],
		title: {
			text: "Daily Prices",
			align: "left",
		},
		markers: {
			size: 0,
			hover: {
				sizeOffset: 6,
			},
		},
		theme: {
			mode: "dark",
			palette: "palette1",
			monochrome: {
				enabled: false,
				color: "#255aee",
				shadeTo: "light",
				shadeIntensity: 0.65,
			},
		},
		grid: {
			borderColor: "#eff2f1",
		},
	};
	return (
		<>
			<ReactApexChart
				options={options}
				series={series}
				type="candlestick"
				height={350}
			/>
		</>
	);
};

export default Chart;
